import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  totalPanel: {
    color: '#fff',
    backgroundColor: '#0078CC'
  },
  socialValueTitle: {
    marginTop: 18
  },
  socialValue: {
    fontWeight: 700
  },
  investmentValue: {
    fontWeight: 700
  },
  rightSide: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 8
  },
  rightSideValue: {
    fontSize: 18,
    fontWeight: 500
  },
  rightSideText: {
    fontSize: 12,
    textAlign: 'center'
  },
  sroiText: {
    maxWidth: 85
  }
})

export default useStyles
